import React from 'react';
import { chakra } from '@chakra-ui/react';
import { useColorMode } from '../color-mode';

type Props = {
  size?: number;
  color?: string;
};

export const TimelineIcon = ({ size = 14, color }: Props) => {
  const { colorMode } = useColorMode();
  const iconColor = color || (colorMode === 'dark' ? '#6B7280' : '#9CA3AF');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M7.14974 12.8346C3.92799 12.8346 1.31641 10.2231 1.31641 7.0013C1.31641 3.77955 3.92799 1.16797 7.14974 1.16797C10.3715 1.16797 12.9831 3.77955 12.9831 7.0013C12.9831 10.2231 10.3715 12.8346 7.14974 12.8346ZM7.14974 11.668C8.38742 11.668 9.5744 11.1763 10.4496 10.3011C11.3247 9.42596 11.8164 8.23898 11.8164 7.0013C11.8164 5.76363 11.3247 4.57664 10.4496 3.70147C9.5744 2.8263 8.38742 2.33464 7.14974 2.33464C5.91206 2.33464 4.72508 2.8263 3.84991 3.70147C2.97474 4.57664 2.48307 5.76363 2.48307 7.0013C2.48307 8.23898 2.97474 9.42596 3.84991 10.3011C4.72508 11.1763 5.91206 11.668 7.14974 11.668ZM7.73307 7.0013H10.0664V8.16797H6.56641V4.08464H7.73307V7.0013Z"
        fill="white"
        fillOpacity="0.4"
      />
    </svg>
  );
};
